import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconFacebook: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 48 48">
          <>
            <path
              fill="currentColor"
              d="M43 24c0-10.493-8.507-19-19-19S5 13.507 5 24c0 9.483 6.948 17.344 16.031 18.77V29.491h-4.824V24h4.824v-4.186c0-4.762 2.837-7.392 7.177-7.392 2.079 0 4.253.371 4.253.371v4.676h-2.396c-2.36 0-3.096 1.464-3.096 2.967V24h5.27l-.843 5.492h-4.427V42.77C36.052 41.344 43 33.483 43 24"
              transform="translate(-105 -1856) translate(80 80) translate(22 1776) translate(3)"
            />
            <path
              fill="#FFFFFF"
              d="M31.396 29.492L32.238 24h-5.27v-3.564c0-1.503.737-2.967 3.097-2.967h2.396v-4.676s-2.174-.371-4.253-.371c-4.34 0-7.177 2.63-7.177 7.392V24h-4.824v5.492h4.824V42.77C22 42.921 22.99 43 24 43c1.01 0 2.001-.079 2.969-.23V29.491h4.427"
              transform="translate(-105 -1856) translate(80 80) translate(22 1776) translate(3)"
            />
          </>
        </svg>
      </div>
    </div>
  )
}
export default IconFacebook
